module.exports = __webpack_public_path__ + "static/raphael-cambion-bg3-0d1a8da512423784b29bd8d83544fce6.jpeg";